import { createContext, useContext } from 'react';

import { useRuleVersionActions } from './RuleVersionActionsProvider.hook';

const RuleVersionActionsContext = createContext<ReturnType<typeof useRuleVersionActions> | undefined>(undefined);
export const RuleVersionActionsContextProvider = RuleVersionActionsContext.Provider;

export const useRuleVersionActionsContext = () => {
  const context = useContext(RuleVersionActionsContext);
  if (!context) {
    throw new Error('useAlertContext must be used within an AlertProvider');
  }
  return context;
};
